import script from "./SettingsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsView.vue?vue&type=script&setup=true&lang=ts"

import "./SettingsView.vue?vue&type=style&index=0&id=76148e26&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76148e26"]])

export default __exports__